(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[882],{

/***/ 14148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AnalyticsConnector; }
/* harmony export */ });
var ApplicationContextProviderImpl = /** @class */ (function () {
    function ApplicationContextProviderImpl() {
    }
    ApplicationContextProviderImpl.prototype.getApplicationContext = function () {
        return {
            versionName: this.versionName,
            language: getLanguage(),
            platform: 'Web',
            os: undefined,
            deviceModel: undefined,
        };
    };
    return ApplicationContextProviderImpl;
}());
var getLanguage = function () {
    return ((typeof navigator !== 'undefined' &&
        ((navigator.languages && navigator.languages[0]) ||
            navigator.language)) ||
        '');
};

var EventBridgeImpl = /** @class */ (function () {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function (event) {
        if (!this.receiver) {
            if (this.queue.length < 512) {
                this.queue.push(event);
            }
        }
        else {
            this.receiver(event);
        }
    };
    EventBridgeImpl.prototype.setEventReceiver = function (receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function (event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}());

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function (obj1, obj2) {
    var primitive = ['string', 'number', 'boolean', 'undefined'];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) {
        return false;
    }
    for (var _i = 0, primitive_1 = primitive; _i < primitive_1.length; _i++) {
        var p = primitive_1[_i];
        if (p === typeA) {
            return obj1 === obj2;
        }
    }
    // check null
    if (obj1 == null && obj2 == null) {
        return true;
    }
    else if (obj1 == null || obj2 == null) {
        return false;
    }
    // if got here - objects
    if (obj1.length !== obj2.length) {
        return false;
    }
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) {
        return false;
    }
    if (isArrayA && isArrayB) {
        //arrays
        for (var i = 0; i < obj1.length; i++) {
            if (!isEqual(obj1[i], obj2[i])) {
                return false;
            }
        }
    }
    else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!isEqual(sorted1, sorted2)) {
            return false;
        }
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function (key) {
            if (!isEqual(obj1[key], obj2[key])) {
                result_1 = false;
            }
        });
        return result_1;
    }
    return true;
};

var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj);
        var i = ownProps.length;
        var resArray = new Array(i);
        while (i--) {
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }
        return resArray;
    };
}
var IdentityStoreImpl = /** @class */ (function () {
    function IdentityStoreImpl() {
        this.identity = { userProperties: {} };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var self = this;
        var actingUserProperties = __assign({}, this.identity.userProperties);
        var actingIdentity = __assign(__assign({}, this.identity), { userProperties: actingUserProperties });
        return {
            setUserId: function (userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function (deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function (userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            setOptOut: function (optOut) {
                actingIdentity.optOut = optOut;
                return this;
            },
            updateUserProperties: function (actions) {
                var actingProperties = actingIdentity.userProperties || {};
                for (var _i = 0, _a = Object.entries(actions); _i < _a.length; _i++) {
                    var _b = _a[_i], action = _b[0], properties = _b[1];
                    switch (action) {
                        case ID_OP_SET:
                            for (var _c = 0, _d = Object.entries(properties); _c < _d.length; _c++) {
                                var _e = _d[_c], key = _e[0], value = _e[1];
                                actingProperties[key] = value;
                            }
                            break;
                        case ID_OP_UNSET:
                            for (var _f = 0, _g = Object.keys(properties); _f < _g.length; _f++) {
                                var key = _g[_f];
                                delete actingProperties[key];
                            }
                            break;
                        case ID_OP_CLEAR_ALL:
                            actingProperties = {};
                            break;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function () {
                self.setIdentity(actingIdentity);
                return this;
            },
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function () {
        return __assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function (identity) {
        var originalIdentity = __assign({}, this.identity);
        this.identity = __assign({}, identity);
        if (!isEqual(originalIdentity, this.identity)) {
            this.listeners.forEach(function (listener) {
                listener(identity);
            });
        }
    };
    IdentityStoreImpl.prototype.addIdentityListener = function (listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function (listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}());

var safeGlobal = typeof globalThis !== 'undefined'
    ? globalThis
    : typeof __webpack_require__.g !== 'undefined'
        ? __webpack_require__.g
        : self;

var AnalyticsConnector = /** @class */ (function () {
    function AnalyticsConnector() {
        this.identityStore = new IdentityStoreImpl();
        this.eventBridge = new EventBridgeImpl();
        this.applicationContextProvider = new ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function (instanceName) {
        if (!safeGlobal['analyticsConnectorInstances']) {
            safeGlobal['analyticsConnectorInstances'] = {};
        }
        if (!safeGlobal['analyticsConnectorInstances'][instanceName]) {
            safeGlobal['analyticsConnectorInstances'][instanceName] =
                new AnalyticsConnector();
        }
        return safeGlobal['analyticsConnectorInstances'][instanceName];
    };
    return AnalyticsConnector;
}());




/***/ }),

/***/ 29293:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.33
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment.
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {
  "use strict";

  //////////////
  // Constants
  /////////////

  var LIBVERSION = "0.7.33",
    EMPTY = "",
    UNKNOWN = "?",
    FUNC_TYPE = "function",
    UNDEF_TYPE = "undefined",
    OBJ_TYPE = "object",
    STR_TYPE = "string",
    MAJOR = "major",
    MODEL = "model",
    NAME = "name",
    TYPE = "type",
    VENDOR = "vendor",
    VERSION = "version",
    ARCHITECTURE = "architecture",
    CONSOLE = "console",
    MOBILE = "mobile",
    TABLET = "tablet",
    SMARTTV = "smarttv",
    WEARABLE = "wearable",
    EMBEDDED = "embedded",
    UA_MAX_LENGTH = 350;

  var AMAZON = "Amazon",
    APPLE = "Apple",
    ASUS = "ASUS",
    BLACKBERRY = "BlackBerry",
    BROWSER = "Browser",
    CHROME = "Chrome",
    EDGE = "Edge",
    FIREFOX = "Firefox",
    GOOGLE = "Google",
    HUAWEI = "Huawei",
    LG = "LG",
    MICROSOFT = "Microsoft",
    MOTOROLA = "Motorola",
    OPERA = "Opera",
    SAMSUNG = "Samsung",
    SHARP = "Sharp",
    SONY = "Sony",
    XIAOMI = "Xiaomi",
    ZEBRA = "Zebra",
    FACEBOOK = "Facebook";

  ///////////
  // Helper
  //////////

  var extend = function (regexes, extensions) {
      var mergedRegexes = {};
      for (var i in regexes) {
        if (extensions[i] && extensions[i].length % 2 === 0) {
          mergedRegexes[i] = extensions[i].concat(regexes[i]);
        } else {
          mergedRegexes[i] = regexes[i];
        }
      }
      return mergedRegexes;
    },
    enumerize = function (arr) {
      var enums = {};
      for (var i = 0; i < arr.length; i++) {
        enums[arr[i].toUpperCase()] = arr[i];
      }
      return enums;
    },
    has = function (str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    },
    lowerize = function (str) {
      return str.toLowerCase();
    },
    majorize = function (version) {
      return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    },
    trim = function (str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };

  ///////////////
  // Map helper
  //////////////

  var rgxMapper = function (ua, arrays) {
      var i = 0,
        j,
        k,
        p,
        q,
        matches,
        match;

      // loop through all regexes maps
      while (i < arrays.length && !matches) {
        var regex = arrays[i], // even sequence (0,2,4,..)
          props = arrays[i + 1]; // odd sequence (1,3,5,..)
        j = k = 0;

        // try matching uastring with regexes
        while (j < regex.length && !matches) {
          matches = regex[j++].exec(ua);

          if (!!matches) {
            for (p = 0; p < props.length; p++) {
              match = matches[++k];
              q = props[p];
              // check if given property is actually array
              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length === 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    // assign modified match
                    this[q[0]] = q[1].call(this, match);
                  } else {
                    // assign given value, ignore regex match
                    this[q[0]] = q[1];
                  }
                } else if (q.length === 3) {
                  // check whether function or regex
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    // call function (usually string mapper)
                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                  } else {
                    // sanitize match using given regex
                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                  }
                } else if (q.length === 4) {
                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                }
              } else {
                this[q] = match ? match : undefined;
              }
            }
          }
        }
        i += 2;
      }
    },
    strMapper = function (str, map) {
      for (var i in map) {
        // check if current value is array
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (has(map[i][j], str)) {
              return i === UNKNOWN ? undefined : i;
            }
          }
        } else if (has(map[i], str)) {
          return i === UNKNOWN ? undefined : i;
        }
      }
      return str;
    };

  ///////////////
  // String map
  //////////////

  // Safari < 3.0
  var oldSafariMap = {
      "1.0": "/8",
      1.2: "/1",
      1.3: "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    },
    windowsVersionMap = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2000: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      8.1: "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    };

  //////////////
  // Regex map
  /////////////

  var regexes = {
    browser: [
      [
        /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
      ],
      [VERSION, [NAME, "Chrome"]],
      [
        /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
      ],
      [VERSION, [NAME, "Edge"]],
      [
        // Presto based
        /(opera mini)\/([-\w\.]+)/i, // Opera Mini
        /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, // Opera Mobi/Tablet
        /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
      ],
      [NAME, VERSION],
      [
        /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
      ],
      [VERSION, [NAME, OPERA + " Mini"]],
      [
        /\bopr\/([\w\.]+)/i // Opera Webkit
      ],
      [VERSION, [NAME, OPERA]],
      [
        // Mixed
        /(kindle)\/([\w\.]+)/i, // Kindle
        /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, // Lunascape/Maxthon/Netfront/Jasmine/Blazer
        // Trident based
        /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i, // Avant/IEMobile/SlimBrowser
        /(ba?idubrowser)[\/ ]?([\w\.]+)/i, // Baidu Browser
        /(?:ms|\()(ie) ([\w\.]+)/i, // Internet Explorer

        // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
        /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
        // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
        /(weibo)__([\d\.]+)/i // Weibo
      ],
      [NAME, VERSION],
      [
        /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
      ],
      [VERSION, [NAME, "UC" + BROWSER]],
      [
        /microm.+\bqbcore\/([\w\.]+)/i, // WeChat Desktop for Windows Built-in Browser
        /\bqbcore\/([\w\.]+).+microm/i
      ],
      [VERSION, [NAME, "WeChat(Win) Desktop"]],
      [
        /micromessenger\/([\w\.]+)/i // WeChat
      ],
      [VERSION, [NAME, "WeChat"]],
      [
        /konqueror\/([\w\.]+)/i // Konqueror
      ],
      [VERSION, [NAME, "Konqueror"]],
      [
        /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
      ],
      [VERSION, [NAME, "IE"]],
      [
        /yabrowser\/([\w\.]+)/i // Yandex
      ],
      [VERSION, [NAME, "Yandex"]],
      [
        /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
      ],
      [[NAME, /(.+)/, "$1 Secure " + BROWSER], VERSION],
      [
        /\bfocus\/([\w\.]+)/i // Firefox Focus
      ],
      [VERSION, [NAME, FIREFOX + " Focus"]],
      [
        /\bopt\/([\w\.]+)/i // Opera Touch
      ],
      [VERSION, [NAME, OPERA + " Touch"]],
      [
        /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
      ],
      [VERSION, [NAME, "Coc Coc"]],
      [
        /dolfin\/([\w\.]+)/i // Dolphin
      ],
      [VERSION, [NAME, "Dolphin"]],
      [
        /coast\/([\w\.]+)/i // Opera Coast
      ],
      [VERSION, [NAME, OPERA + " Coast"]],
      [
        /miuibrowser\/([\w\.]+)/i // MIUI Browser
      ],
      [VERSION, [NAME, "MIUI " + BROWSER]],
      [
        /fxios\/([-\w\.]+)/i // Firefox for iOS
      ],
      [VERSION, [NAME, FIREFOX]],
      [
        /\bqihu|(qi?ho?o?|360)browser/i // 360
      ],
      [[NAME, "360 " + BROWSER]],
      [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],
      [[NAME, /(.+)/, "$1 " + BROWSER], VERSION],
      [
        // Oculus/Samsung/Sailfish/Huawei Browser
        /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
      ],
      [[NAME, /_/g, " "], VERSION],
      [
        /(electron)\/([\w\.]+) safari/i, // Electron-based App
        /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, // Tesla
        /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/Baidu App/2345 Browser
      ],
      [NAME, VERSION],
      [
        /(metasr)[\/ ]?([\w\.]+)/i, // SouGouBrowser
        /(lbbrowser)/i, // LieBao Browser
        /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
      ],
      [NAME],
      [
        // WebView
        /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
      ],
      [[NAME, FACEBOOK], VERSION],
      [
        /safari (line)\/([\w\.]+)/i, // Line App for iOS
        /\b(line)\/([\w\.]+)\/iab/i, // Line App for Android
        /(chromium|instagram)[\/ ]([-\w\.]+)/i // Chromium/Instagram
      ],
      [NAME, VERSION],
      [
        /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
      ],
      [VERSION, [NAME, "GSA"]],
      [
        /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
      ],
      [VERSION, [NAME, CHROME + " Headless"]],
      [
        / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
      ],
      [[NAME, CHROME + " WebView"], VERSION],
      [
        /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
      ],
      [VERSION, [NAME, "Android " + BROWSER]],
      [
        /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
      ],
      [NAME, VERSION],
      [
        /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
      ],
      [VERSION, [NAME, "Mobile Safari"]],
      [
        /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
      ],
      [VERSION, NAME],
      [
        /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
      ],
      [NAME, [VERSION, strMapper, oldSafariMap]],
      [/(webkit|khtml)\/([\w\.]+)/i],
      [NAME, VERSION],
      [
        // Gecko based
        /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
      ],
      [[NAME, "Netscape"], VERSION],
      [
        /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
      ],
      [VERSION, [NAME, FIREFOX + " Reality"]],
      [
        /ekiohf.+(flow)\/([\w\.]+)/i, // Flow
        /(swiftfox)/i, // Swiftfox
        /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
        // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
        /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
        // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
        /(firefox)\/([\w\.]+)/i, // Other Firefox-based
        /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, // Mozilla

        // Other
        /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
        // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
        /(links) \(([\w\.]+)/i // Links
      ],
      [NAME, VERSION],
      [
        /(cobalt)\/([\w\.]+)/i // Cobalt
      ],
      [NAME, [VERSION, /master.|lts./, ""]]
    ],

    cpu: [
      [
        /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
      ],
      [[ARCHITECTURE, "amd64"]],
      [
        /(ia32(?=;))/i // IA32 (quicktime)
      ],
      [[ARCHITECTURE, lowerize]],
      [
        /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
      ],
      [[ARCHITECTURE, "ia32"]],
      [
        /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
      ],
      [[ARCHITECTURE, "arm64"]],
      [
        /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
      ],
      [[ARCHITECTURE, "armhf"]],
      [
        // PocketPC mistakenly identified as PowerPC
        /windows (ce|mobile); ppc;/i
      ],
      [[ARCHITECTURE, "arm"]],
      [
        /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
      ],
      [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
      [
        /(sun4\w)[;\)]/i // SPARC
      ],
      [[ARCHITECTURE, "sparc"]],
      [
        /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
      ],
      [[ARCHITECTURE, lowerize]]
    ],

    device: [
      [
        //////////////////////////
        // MOBILES & TABLETS
        // Ordered by popularity
        /////////////////////////

        // Samsung
        /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
      ],
      [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
      [
        /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
        /samsung[- ]([-\w]+)/i,
        /sec-(sgh\w+)/i
      ],
      [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
      [
        // Apple
        /((ipod|iphone)\d+,\d+)/i // iPod/iPhone model
      ],
      [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
      [
        /(ipad\d+,\d+)/i // iPad model
      ],
      [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
      [
        /\((ip(?:hone|od)[\w ]*);/i // iPod/iPhone
      ],
      [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
      [
        /\((ipad);[-\w\),; ]+apple/i, // iPad
        /applecoremedia\/[\w\.]+ \((ipad)/i,
        /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
      ],
      [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
      [/(macintosh);/i],
      [MODEL, [VENDOR, APPLE]],
      [
        // Huawei
        /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
      ],
      [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
      [
        /(?:huawei|honor)([-\w ]+)[;\)]/i,
        /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
      ],
      [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
      [
        // Xiaomi
        /\b(poco[\w ]+)(?: bui|\))/i, // Xiaomi POCO
        /\b; (\w+) build\/hm\1/i, // Xiaomi Hongmi 'numeric' models
        /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, // Xiaomi Hongmi
        /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, // Xiaomi Redmi
        /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
      ],
      [
        [MODEL, /_/g, " "],
        [VENDOR, XIAOMI],
        [TYPE, MOBILE]
      ],
      [
        /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
      ],
      [
        [MODEL, /_/g, " "],
        [VENDOR, XIAOMI],
        [TYPE, TABLET]
      ],
      [
        // OPPO
        /; (\w+) bui.+ oppo/i,
        /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
      ],
      [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
      [
        // Vivo
        /vivo (\w+)(?: bui|\))/i,
        /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
      ],
      [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
      [
        // Realme
        /\b(rmx[12]\d{3})(?: bui|;|\))/i
      ],
      [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
      [
        // Motorola
        /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
        /\bmot(?:orola)?[- ](\w*)/i,
        /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
      ],
      [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
      [/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
      [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
      [
        // LG
        /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
      ],
      [MODEL, [VENDOR, LG], [TYPE, TABLET]],
      [
        /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
        /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
        /\blg-?([\d\w]+) bui/i
      ],
      [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
      [
        // Lenovo
        /(ideatab[-\w ]+)/i,
        /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
      ],
      [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
      [
        // Nokia
        /(?:maemo|nokia).*(n900|lumia \d+)/i,
        /nokia[-_ ]?([-\w\.]*)/i
      ],
      [
        [MODEL, /_/g, " "],
        [VENDOR, "Nokia"],
        [TYPE, MOBILE]
      ],
      [
        // Google
        /(pixel c)\b/i // Google Pixel C
      ],
      [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
      [
        /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
      ],
      [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
      [
        // Sony
        /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
      ],
      [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
      [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
      [
        [MODEL, "Xperia Tablet"],
        [VENDOR, SONY],
        [TYPE, TABLET]
      ],
      [
        // OnePlus
        / (kb2005|in20[12]5|be20[12][59])\b/i,
        /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
      ],
      [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
      [
        // Amazon
        /(alexa)webm/i,
        /(kf[a-z]{2}wi)( bui|\))/i, // Kindle Fire without Silk
        /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
      ],
      [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
      [
        /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
      ],
      [
        [MODEL, /(.+)/g, "Fire Phone $1"],
        [VENDOR, AMAZON],
        [TYPE, MOBILE]
      ],
      [
        // BlackBerry
        /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
      ],
      [MODEL, VENDOR, [TYPE, TABLET]],
      [
        /\b((?:bb[a-f]|st[hv])100-\d)/i,
        /\(bb10; (\w+)/i // BlackBerry 10
      ],
      [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
      [
        // Asus
        /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
      ],
      [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
      [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
      [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
      [
        // HTC
        /(nexus 9)/i // HTC Nexus 9
      ],
      [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
      [
        /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, // HTC

        // ZTE
        /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
        /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
      ],
      [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
      [
        // Acer
        /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
      ],
      [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
      [
        // Meizu
        /droid.+; (m[1-5] note) bui/i,
        /\bmz-([-\w]{2,})/i
      ],
      [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
      [
        // Sharp
        /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
      ],
      [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
      [
        // MIXED
        /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
        // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
        /(hp) ([\w ]+\w)/i, // HP iPAQ
        /(asus)-?(\w+)/i, // Asus
        /(microsoft); (lumia[\w ]+)/i, // Microsoft Lumia
        /(lenovo)[-_ ]?([-\w]+)/i, // Lenovo
        /(jolla)/i, // Jolla
        /(oppo) ?([\w ]+) bui/i // OPPO
      ],
      [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /(archos) (gamepad2?)/i, // Archos
        /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
        /(kindle)\/([\w\.]+)/i, // Kindle
        /(nook)[\w ]+build\/(\w+)/i, // Nook
        /(dell) (strea[kpr\d ]*[\dko])/i, // Dell Streak
        /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, // Le Pan Tablets
        /(trinity)[- ]*(t\d{3}) bui/i, // Trinity Tablets
        /(gigaset)[- ]+(q\w{1,9}) bui/i, // Gigaset Tablets
        /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
      ],
      [VENDOR, MODEL, [TYPE, TABLET]],
      [
        /(surface duo)/i // Surface Duo
      ],
      [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
      [
        /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
      ],
      [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
      [
        /(u304aa)/i // AT&T
      ],
      [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
      [
        /\bsie-(\w*)/i // Siemens
      ],
      [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
      [
        /\b(rct\w+) b/i // RCA Tablets
      ],
      [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
      [
        /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
      ],
      [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
      [
        /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
      ],
      [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
      [
        /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
      ],
      [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
      [/\b(tm\d{3}\w+) b/i],
      [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
      [
        /\b(k88) b/i // ZTE K Series Tablet
      ],
      [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
      [
        /\b(nx\d{3}j) b/i // ZTE Nubia
      ],
      [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
      [
        /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
      ],
      [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
      [
        /\b(zur\d{3}) b/i // Swiss ZUR Tablet
      ],
      [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
      [
        /\b((zeki)?tb.*\b) b/i // Zeki Tablets
      ],
      [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
      [
        /\b([yr]\d{2}) b/i,
        /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
      ],
      [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
      [
        /\b(ns-?\w{0,9}) b/i // Insignia Tablets
      ],
      [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
      [
        /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
      ],
      [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
      [
        /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
      ],
      [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
      [
        /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
      ],
      [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
      [
        /\b(ph-1) /i // Essential PH-1
      ],
      [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
      [
        /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
      ],
      [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
      [
        /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
      ],
      [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
      [
        /\btu_(1491) b/i // Rotor Tablets
      ],
      [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
      [
        /(shield[\w ]+) b/i // Nvidia Shield Tablets
      ],
      [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
      [
        /(sprint) (\w+)/i // Sprint Phones
      ],
      [VENDOR, MODEL, [TYPE, MOBILE]],
      [
        /(kin\.[onetw]{3})/i // Microsoft Kin
      ],
      [
        [MODEL, /\./g, " "],
        [VENDOR, MICROSOFT],
        [TYPE, MOBILE]
      ],
      [
        /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
      ],
      [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
      [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
      [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
      [
        ///////////////////
        // CONSOLES
        ///////////////////

        /(ouya)/i, // Ouya
        /(nintendo) ([wids3utch]+)/i // Nintendo
      ],
      [VENDOR, MODEL, [TYPE, CONSOLE]],
      [
        /droid.+; (shield) bui/i // Nvidia
      ],
      [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]],
      [
        /(playstation [345portablevi]+)/i // Playstation
      ],
      [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
      [
        /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
      ],
      [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
      [
        ///////////////////
        // SMARTTVS
        ///////////////////

        /smart-tv.+(samsung)/i // Samsung
      ],
      [VENDOR, [TYPE, SMARTTV]],
      [/hbbtv.+maple;(\d+)/i],
      [
        [MODEL, /^/, "SmartTV"],
        [VENDOR, SAMSUNG],
        [TYPE, SMARTTV]
      ],
      [
        /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
      ],
      [
        [VENDOR, LG],
        [TYPE, SMARTTV]
      ],
      [
        /(apple) ?tv/i // Apple TV
      ],
      [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
      [
        /crkey/i // Google Chromecast
      ],
      [
        [MODEL, CHROME + "cast"],
        [VENDOR, GOOGLE],
        [TYPE, SMARTTV]
      ],
      [
        /droid.+aft(\w)( bui|\))/i // Fire TV
      ],
      [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
      [
        /\(dtv[\);].+(aquos)/i,
        /(aquos-tv[\w ]+)\)/i // Sharp
      ],
      [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
      [
        /(bravia[\w ]+)( bui|\))/i // Sony
      ],
      [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
      [
        /(mitv-\w{5}) bui/i // Xiaomi
      ],
      [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
      [
        /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, // Roku
        /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i // HbbTV devices
      ],
      [
        [VENDOR, trim],
        [MODEL, trim],
        [TYPE, SMARTTV]
      ],
      [
        /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
      ],
      [[TYPE, SMARTTV]],
      [
        ///////////////////
        // WEARABLES
        ///////////////////

        /((pebble))app/i // Pebble
      ],
      [VENDOR, MODEL, [TYPE, WEARABLE]],
      [
        /droid.+; (glass) \d/i // Google Glass
      ],
      [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
      [/droid.+; (wt63?0{2,3})\)/i],
      [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
      [
        /(quest( 2)?)/i // Oculus Quest
      ],
      [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
      [
        ///////////////////
        // EMBEDDED
        ///////////////////

        /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
      ],
      [VENDOR, [TYPE, EMBEDDED]],
      [
        ////////////////////
        // MIXED (GENERIC)
        ///////////////////

        /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
      ],
      [MODEL, [TYPE, MOBILE]],
      [
        /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
      ],
      [MODEL, [TYPE, TABLET]],
      [
        /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
      ],
      [[TYPE, TABLET]],
      [
        /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
      ],
      [[TYPE, MOBILE]],
      [
        /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
      ],
      [MODEL, [VENDOR, "Generic"]]
    ],

    engine: [
      [
        /windows.+ edge\/([\w\.]+)/i // EdgeHTML
      ],
      [VERSION, [NAME, EDGE + "HTML"]],
      [
        /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
      ],
      [VERSION, [NAME, "Blink"]],
      [
        /(presto)\/([\w\.]+)/i, // Presto
        /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
        /ekioh(flow)\/([\w\.]+)/i, // Flow
        /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, // KHTML/Tasman/Links
        /(icab)[\/ ]([23]\.[\d\.]+)/i // iCab
      ],
      [NAME, VERSION],
      [
        /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
      ],
      [VERSION, NAME]
    ],

    os: [
      [
        // Windows
        /microsoft (windows) (vista|xp)/i // Windows (iTunes)
      ],
      [NAME, VERSION],
      [
        /(windows) nt 6\.2; (arm)/i, // Windows RT
        /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i, // Windows Phone
        /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
      ],
      [NAME, [VERSION, strMapper, windowsVersionMap]],
      [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],
      [
        [NAME, "Windows"],
        [VERSION, strMapper, windowsVersionMap]
      ],
      [
        // iOS/macOS
        /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, // iOS
        /cfnetwork\/.+darwin/i
      ],
      [
        [VERSION, /_/g, "."],
        [NAME, "iOS"]
      ],
      [
        /(mac os x) ?([\w\. ]*)/i,
        /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
      ],
      [
        [NAME, "Mac OS"],
        [VERSION, /_/g, "."]
      ],
      [
        // Mobile OSes
        /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
      ],
      [VERSION, NAME],
      [
        // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
        /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
        /(blackberry)\w*\/([\w\.]*)/i, // Blackberry
        /(tizen|kaios)[\/ ]([\w\.]+)/i, // Tizen/KaiOS
        /\((series40);/i // Series 40
      ],
      [NAME, VERSION],
      [
        /\(bb(10);/i // BlackBerry 10
      ],
      [VERSION, [NAME, BLACKBERRY]],
      [
        /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
      ],
      [VERSION, [NAME, "Symbian"]],
      [
        /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
      ],
      [VERSION, [NAME, FIREFOX + " OS"]],
      [
        /web0s;.+rt(tv)/i,
        /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
      ],
      [VERSION, [NAME, "webOS"]],
      [
        // Google Chromecast
        /crkey\/([\d\.]+)/i // Google Chromecast
      ],
      [VERSION, [NAME, CHROME + "cast"]],
      [
        /(cros) [\w]+ ([\w\.]+\w)/i // Chromium OS
      ],
      [[NAME, "Chromium OS"], VERSION],
      [
        // Console
        /(nintendo|playstation) ([wids345portablevuch]+)/i, // Nintendo/Playstation
        /(xbox); +xbox ([^\);]+)/i, // Microsoft Xbox (360, One, X, S, Series X, Series S)

        // Other
        /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, // Joli/Palm
        /(mint)[\/\(\) ]?(\w*)/i, // Mint
        /(mageia|vectorlinux)[; ]/i, // Mageia/VectorLinux
        /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
        // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
        /(hurd|linux) ?([\w\.]*)/i, // Hurd/Linux
        /(gnu) ?([\w\.]*)/i, // GNU
        /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
        /(haiku) (\w+)/i // Haiku
      ],
      [NAME, VERSION],
      [
        /(sunos) ?([\w\.\d]*)/i // Solaris
      ],
      [[NAME, "Solaris"], VERSION],
      [
        /((?:open)?solaris)[-\/ ]?([\w\.]*)/i, // Solaris
        /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, // AIX
        /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i, // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
        /(unix) ?([\w\.]*)/i // UNIX
      ],
      [NAME, VERSION]
    ]
  };

  /////////////////
  // Constructor
  ////////////////

  var UAParser = function (ua, extensions) {
    if (typeof ua === OBJ_TYPE) {
      extensions = ua;
      ua = undefined;
    }

    if (!(this instanceof UAParser)) {
      return new UAParser(ua, extensions).getResult();
    }

    var _ua =
      ua ||
      (typeof window !== UNDEF_TYPE &&
      window.navigator &&
      window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
    var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

    this.getBrowser = function () {
      var _browser = {};
      _browser[NAME] = undefined;
      _browser[VERSION] = undefined;
      rgxMapper.call(_browser, _ua, _rgxmap.browser);
      _browser.major = majorize(_browser.version);
      return _browser;
    };
    this.getCPU = function () {
      var _cpu = {};
      _cpu[ARCHITECTURE] = undefined;
      rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
      return _cpu;
    };
    this.getDevice = function () {
      var _device = {};
      _device[VENDOR] = undefined;
      _device[MODEL] = undefined;
      _device[TYPE] = undefined;
      rgxMapper.call(_device, _ua, _rgxmap.device);
      return _device;
    };
    this.getEngine = function () {
      var _engine = {};
      _engine[NAME] = undefined;
      _engine[VERSION] = undefined;
      rgxMapper.call(_engine, _ua, _rgxmap.engine);
      return _engine;
    };
    this.getOS = function () {
      var _os = {};
      _os[NAME] = undefined;
      _os[VERSION] = undefined;
      rgxMapper.call(_os, _ua, _rgxmap.os);
      return _os;
    };
    this.getResult = function () {
      return {
        ua: this.getUA(),
        browser: this.getBrowser(),
        engine: this.getEngine(),
        os: this.getOS(),
        device: this.getDevice(),
        cpu: this.getCPU()
      };
    };
    this.getUA = function () {
      return _ua;
    };
    this.setUA = function (ua) {
      _ua =
        typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
      return this;
    };
    this.setUA(_ua);
    return this;
  };

  UAParser.VERSION = LIBVERSION;
  UAParser.BROWSER = enumerize([NAME, VERSION, MAJOR]);
  UAParser.CPU = enumerize([ARCHITECTURE]);
  UAParser.DEVICE = enumerize([
    MODEL,
    VENDOR,
    TYPE,
    CONSOLE,
    MOBILE,
    SMARTTV,
    TABLET,
    WEARABLE,
    EMBEDDED
  ]);
  UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

  ///////////
  // Export
  //////////

  // check js environment
  if (typeof exports !== UNDEF_TYPE) {
    // nodejs env
    if ("object" !== UNDEF_TYPE && module.exports) {
      exports = module.exports = UAParser;
    }
    exports.UAParser = UAParser;
  } else {
    // requirejs env (optional)
    if ("function" === FUNC_TYPE && __webpack_require__.amdO) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return UAParser;
      }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof window !== UNDEF_TYPE) {
      // browser env
      window.UAParser = UAParser;
    }
  }

  // jQuery/Zepto specific (optional)
  // Note:
  //   In AMD env the global scope should be kept clean, but jQuery is an exception.
  //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
  //   and we should catch that.
  var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
  if ($ && !$.ua) {
    var parser = new UAParser();
    $.ua = parser.getResult();
    $.ua.get = function () {
      return parser.getUA();
    };
    $.ua.set = function (ua) {
      parser.setUA(ua);
      var result = parser.getResult();
      for (var prop in result) {
        $.ua[prop] = result[prop];
      }
    };
  }
})(typeof window === "object" ? window : this);


/***/ }),

/***/ 58433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XQ": function() { return /* binding */ prototypeJsFix; },
/* harmony export */   "kP": function() { return /* binding */ isBrowserEnv; }
/* harmony export */ });
/* unused harmony exports isNodeEnv, getGlobalObject, getGlobalAmplitudeNamespace, asyncSleep */
/* provided dependency */ var process = __webpack_require__(34155);

/**
 * Checks whether we're in a Node.js environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    var _a;
    return typeof process === 'object' && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) !== undefined;
}
/**
 * Checks whether we're in a browser environment
 *
 * @returns Answer to given question
 */
function isBrowserEnv() {
    return typeof window === 'object' && (window === null || window === void 0 ? void 0 : window.document) !== undefined;
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
var getGlobalObject = function () {
    if (isNodeEnv()) {
        return __webpack_require__.g;
    }
    else if (typeof window !== 'undefined') {
        return window;
    }
    else if (typeof self !== 'undefined') {
        return self;
    }
    else {
        return fallbackGlobalObject;
    }
};
var getGlobalAmplitudeNamespace = function () {
    var global = getGlobalObject();
    if (global.__AMPLITUDE__ === undefined) {
        global.__AMPLITUDE__ = {};
    }
    return global.__AMPLITUDE__;
};
/**
 * A promise-based way to sleep for x millseconds, then queue ourselves back to the
 * JS event loop.
 *
 * @param milliseconds The number of milliseconds to wait for
 */
var asyncSleep = function (milliseconds) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, milliseconds); })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Fixes browser edge case where Prototype.js injects Array.prototype.toJSON and breaks the built-in JSON.stringify()
 *
 * @returns true if Array.prototype.toJSON was deleted, false if not
 */
var prototypeJsFix = function () {
    var _a;
    if (isBrowserEnv()) {
        var augmentedWindow = window;
        var augmentedArray = Array;
        if (augmentedWindow.Prototype !== undefined && ((_a = augmentedArray.prototype) === null || _a === void 0 ? void 0 : _a.toJSON) !== undefined) {
            delete augmentedArray.prototype.toJSON;
            return true;
        }
    }
    return false;
};
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ 99560:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/* global define */

/* eslint-disable strict */

;(function ($) {
  'use strict'

  /**
   * Add integers, wrapping at 2^32.
   * This uses 16-bit operations internally to work around bugs in interpreters.
   *
   * @param {number} x First integer
   * @param {number} y Second integer
   * @returns {number} Sum
   */
  function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff)
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
    return (msw << 16) | (lsw & 0xffff)
  }

  /**
   * Bitwise rotate a 32-bit number to the left.
   *
   * @param {number} num 32-bit number
   * @param {number} cnt Rotation count
   * @returns {number} Rotated number
   */
  function bitRotateLeft(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt))
  }

  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} q q
   * @param {number} a a
   * @param {number} b b
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5ff(a, b, c, d, x, s, t) {
    return md5cmn((b & c) | (~b & d), a, b, x, s, t)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5gg(a, b, c, d, x, s, t) {
    return md5cmn((b & d) | (c & ~d), a, b, x, s, t)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t)
  }
  /**
   * Basic operation the algorithm uses.
   *
   * @param {number} a a
   * @param {number} b b
   * @param {number} c c
   * @param {number} d d
   * @param {number} x x
   * @param {number} s s
   * @param {number} t t
   * @returns {number} Result
   */
  function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t)
  }

  /**
   * Calculate the MD5 of an array of little-endian words, and a bit length.
   *
   * @param {Array} x Array of little-endian words
   * @param {number} len Bit length
   * @returns {Array<number>} MD5 Array
   */
  function binlMD5(x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << len % 32
    x[(((len + 64) >>> 9) << 4) + 14] = len

    var i
    var olda
    var oldb
    var oldc
    var oldd
    var a = 1732584193
    var b = -271733879
    var c = -1732584194
    var d = 271733878

    for (i = 0; i < x.length; i += 16) {
      olda = a
      oldb = b
      oldc = c
      oldd = d

      a = md5ff(a, b, c, d, x[i], 7, -680876936)
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586)
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819)
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330)
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897)
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426)
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341)
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983)
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416)
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417)
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063)
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162)
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682)
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101)
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290)
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329)

      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510)
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632)
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713)
      b = md5gg(b, c, d, a, x[i], 20, -373897302)
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691)
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083)
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335)
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848)
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438)
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690)
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961)
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501)
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467)
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784)
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473)
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734)

      a = md5hh(a, b, c, d, x[i + 5], 4, -378558)
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463)
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562)
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556)
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060)
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353)
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632)
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640)
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174)
      d = md5hh(d, a, b, c, x[i], 11, -358537222)
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979)
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189)
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487)
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835)
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520)
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651)

      a = md5ii(a, b, c, d, x[i], 6, -198630844)
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415)
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905)
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055)
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571)
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606)
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523)
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799)
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359)
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744)
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380)
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649)
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070)
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379)
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259)
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551)

      a = safeAdd(a, olda)
      b = safeAdd(b, oldb)
      c = safeAdd(c, oldc)
      d = safeAdd(d, oldd)
    }
    return [a, b, c, d]
  }

  /**
   * Convert an array of little-endian words to a string
   *
   * @param {Array<number>} input MD5 Array
   * @returns {string} MD5 string
   */
  function binl2rstr(input) {
    var i
    var output = ''
    var length32 = input.length * 32
    for (i = 0; i < length32; i += 8) {
      output += String.fromCharCode((input[i >> 5] >>> i % 32) & 0xff)
    }
    return output
  }

  /**
   * Convert a raw string to an array of little-endian words
   * Characters >255 have their high-byte silently ignored.
   *
   * @param {string} input Raw input string
   * @returns {Array<number>} Array of little-endian words
   */
  function rstr2binl(input) {
    var i
    var output = []
    output[(input.length >> 2) - 1] = undefined
    for (i = 0; i < output.length; i += 1) {
      output[i] = 0
    }
    var length8 = input.length * 8
    for (i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32
    }
    return output
  }

  /**
   * Calculate the MD5 of a raw string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */
  function rstrMD5(s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8))
  }

  /**
   * Calculates the HMAC-MD5 of a key and some data (raw strings)
   *
   * @param {string} key HMAC key
   * @param {string} data Raw input string
   * @returns {string} Raw MD5 string
   */
  function rstrHMACMD5(key, data) {
    var i
    var bkey = rstr2binl(key)
    var ipad = []
    var opad = []
    var hash
    ipad[15] = opad[15] = undefined
    if (bkey.length > 16) {
      bkey = binlMD5(bkey, key.length * 8)
    }
    for (i = 0; i < 16; i += 1) {
      ipad[i] = bkey[i] ^ 0x36363636
      opad[i] = bkey[i] ^ 0x5c5c5c5c
    }
    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8)
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128))
  }

  /**
   * Convert a raw string to a hex string
   *
   * @param {string} input Raw input string
   * @returns {string} Hex encoded string
   */
  function rstr2hex(input) {
    var hexTab = '0123456789abcdef'
    var output = ''
    var x
    var i
    for (i = 0; i < input.length; i += 1) {
      x = input.charCodeAt(i)
      output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f)
    }
    return output
  }

  /**
   * Encode a string as UTF-8
   *
   * @param {string} input Input string
   * @returns {string} UTF8 string
   */
  function str2rstrUTF8(input) {
    return unescape(encodeURIComponent(input))
  }

  /**
   * Encodes input string as raw MD5 string
   *
   * @param {string} s Input string
   * @returns {string} Raw MD5 string
   */
  function rawMD5(s) {
    return rstrMD5(str2rstrUTF8(s))
  }
  /**
   * Encodes input string as Hex encoded string
   *
   * @param {string} s Input string
   * @returns {string} Hex encoded string
   */
  function hexMD5(s) {
    return rstr2hex(rawMD5(s))
  }
  /**
   * Calculates the raw HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */
  function rawHMACMD5(k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d))
  }
  /**
   * Calculates the Hex encoded HMAC-MD5 for the given key and data
   *
   * @param {string} k HMAC key
   * @param {string} d Input string
   * @returns {string} Raw MD5 string
   */
  function hexHMACMD5(k, d) {
    return rstr2hex(rawHMACMD5(k, d))
  }

  /**
   * Calculates MD5 value for a given string.
   * If a key is provided, calculates the HMAC-MD5 value.
   * Returns a Hex encoded string unless the raw argument is given.
   *
   * @param {string} string Input string
   * @param {string} [key] HMAC key
   * @param {boolean} [raw] Raw output switch
   * @returns {string} MD5 output
   */
  function md5(string, key, raw) {
    if (!key) {
      if (!raw) {
        return hexMD5(string)
      }
      return rawMD5(string)
    }
    if (!raw) {
      return hexHMACMD5(key, string)
    }
    return rawHMACMD5(key, string)
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return md5
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else {}
})(this)


/***/ }),

/***/ 55470:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CareAmpli": function() { return /* reexport */ CareAmpli; },
  "DEFAULT_AMPLI_INSTANCE_NAME": function() { return /* reexport */ DEFAULT_AMPLI_INSTANCE_NAME; },
  "getInstance": function() { return /* binding */ getInstance; },
  "init": function() { return /* binding */ init; },
  "logEvent": function() { return /* binding */ logEvent; },
  "setUserProps": function() { return /* binding */ setUserProps; },
  "updateCommonData": function() { return /* binding */ updateCommonData; }
});

// EXTERNAL MODULE: ./node_modules/amplitude-js/amplitude.esm.js
var amplitude_esm = __webpack_require__(17380);
;// CONCATENATED MODULE: ./node_modules/@care/analytics/dist/__generated__/ampli/index.js
/* tslint:disable */
/* eslint-disable */
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull none'
 *
 * Required dependencies: amplitude-js@^8.18.0
 * Tracking Plan Version: 5
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli
 *
 * [View Tracking Plan](https://data.amplitude.com/caredotcom/Care.com%20v2/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/caredotcom/Care.com%20v2/implementation/none)
 */

const ApiKey = {
    development: 'e47fd687db6356aa118e0359bb93c3e6',
    production: ''
};
/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
const DefaultOptions = {
    plan: {
        version: '5',
        branch: 'main',
        source: 'none',
        versionId: '7461e022-2859-412d-a02a-328baac94579'
    }
};
class Identify {
    constructor(event_properties) {
        this.event_properties = event_properties;
        this.event_type = 'Identify';
    }
}
class Group {
    constructor() {
        this.event_type = 'Group';
    }
}
// prettier-ignore
class Ampli {
    constructor() {
        this.disabled = false;
        this.middlewares = [];
    }
    get client() {
        this.isInitializedAndEnabled();
        return this.amplitude;
    }
    get isLoaded() {
        return this.amplitude != null;
    }
    isInitializedAndEnabled() {
        if (!this.isLoaded) {
            console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
            return false;
        }
        return !this.disabled;
    }
    /**
     * Initialize the Ampli SDK. Call once when your application starts.
     * @param options Configuration options to initialize the Ampli SDK with.
     */
    load(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.disabled = (_a = options === null || options === void 0 ? void 0 : options.disabled) !== null && _a !== void 0 ? _a : false;
        if (this.isLoaded) {
            console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
            return;
        }
        const env = (_b = options === null || options === void 0 ? void 0 : options.environment) !== null && _b !== void 0 ? _b : 'development';
        const apiKey = (_d = (_c = options === null || options === void 0 ? void 0 : options.client) === null || _c === void 0 ? void 0 : _c.apiKey) !== null && _d !== void 0 ? _d : ApiKey[env];
        if ((_e = options === null || options === void 0 ? void 0 : options.client) === null || _e === void 0 ? void 0 : _e.instance) {
            this.amplitude = (_f = options === null || options === void 0 ? void 0 : options.client) === null || _f === void 0 ? void 0 : _f.instance;
        }
        else if (apiKey) {
            this.amplitude = amplitude_esm/* default.getInstance */.Z.getInstance();
            (_g = this.amplitude) === null || _g === void 0 ? void 0 : _g.init(apiKey, undefined, Object.assign(Object.assign({}, DefaultOptions), (_h = options === null || options === void 0 ? void 0 : options.client) === null || _h === void 0 ? void 0 : _h.options));
        }
        else {
            console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
        }
    }
    /**
     * Identify a user and set user properties.
     *
     * @param userId The user's id.
     * @param properties The user properties.
     * @param options Optional event options.
     * @param extra Extra unstructured data for middleware.
     */
    identify(userId, properties, options, extra) {
        if (!this.isInitializedAndEnabled()) {
            return;
        }
        const event = {
            event_type: SpecialEventType.Identify,
            event_properties: properties,
            user_id: userId || (options === null || options === void 0 ? void 0 : options.user_id),
            device_id: options === null || options === void 0 ? void 0 : options.device_id
        };
        this.runMiddleware({ event, extra }, payload => {
            var _a, _b, _c;
            const e = payload.event;
            if (e.user_id) {
                (_a = this.amplitude) === null || _a === void 0 ? void 0 : _a.setUserId(e.user_id);
            }
            if (e.device_id) {
                (_b = this.amplitude) === null || _b === void 0 ? void 0 : _b.setDeviceId(e.device_id);
            }
            const amplitudeIdentify = new amplitude_esm/* default.Identify */.Z.Identify();
            if (e.event_properties != null) {
                for (const [key, value] of Object.entries(e.event_properties)) {
                    amplitudeIdentify.set(key, value);
                }
            }
            (_c = this.amplitude) === null || _c === void 0 ? void 0 : _c.identify(amplitudeIdentify, options === null || options === void 0 ? void 0 : options.callback);
        });
    }
    setGroup(name, value, options, extra) {
        var _a;
        if (!this.isInitializedAndEnabled()) {
            return;
        }
        (_a = this.amplitude) === null || _a === void 0 ? void 0 : _a.setGroup(name, value);
    }
    /**
     * Identify a group and set group properties.
     *
     * @param groupType The group type.
     * @param groupName The group name.
     * @param options Optional event options.
     * @param extra Extra unstructured data for middleware.
     */
    groupIdentify(groupType, groupName, options, extra) {
        if (!this.isInitializedAndEnabled()) {
            return;
        }
        const event = {
            event_type: SpecialEventType.Group,
            user_id: options === null || options === void 0 ? void 0 : options.user_id,
            device_id: options === null || options === void 0 ? void 0 : options.device_id
        };
        this.runMiddleware({ event, extra }, payload => {
            var _a, _b, _c;
            const e = payload.event;
            if (e.user_id) {
                (_a = this.amplitude) === null || _a === void 0 ? void 0 : _a.setUserId(e.user_id);
            }
            if (e.device_id) {
                (_b = this.amplitude) === null || _b === void 0 ? void 0 : _b.setDeviceId(e.device_id);
            }
            const amplitudeIdentify = new amplitude_esm/* default.Identify */.Z.Identify();
            if (e.event_properties != null) {
                for (const [key, value] of Object.entries(e.event_properties)) {
                    amplitudeIdentify.set(key, value);
                }
            }
            (_c = this.amplitude) === null || _c === void 0 ? void 0 : _c.groupIdentify(groupType, groupName, amplitudeIdentify, options === null || options === void 0 ? void 0 : options.callback);
        });
    }
    /**
     * Track event
     *
     * @param event The event to track.
     * @param options Optional event options.
     * @param extra Extra unstructured data for middleware.
     */
    track(event, options, extra) {
        if (!this.isInitializedAndEnabled()) {
            return;
        }
        this.runMiddleware({ event, extra }, payload => {
            var _a;
            (_a = this.amplitude) === null || _a === void 0 ? void 0 : _a.logEvent(payload.event.event_type, payload.event.event_properties, options === null || options === void 0 ? void 0 : options.callback);
        });
    }
    addEventMiddleware(middleware) {
        this.middlewares.push(middleware);
    }
    runMiddleware(payload, next) {
        let curMiddlewareIndex = -1;
        const middlewareCount = this.middlewares.length;
        const middlewareNext = curPayload => {
            curMiddlewareIndex += 1;
            if (curMiddlewareIndex < middlewareCount) {
                this.middlewares[curMiddlewareIndex](curPayload, _next);
            }
            else {
                next(curPayload);
            }
        };
        const _next = middlewareCount > 0 ? middlewareNext : next;
        _next(payload);
    }
}
const ampli = new Ampli();
var SpecialEventType;
(function (SpecialEventType) {
    SpecialEventType["Identify"] = "Identify";
    SpecialEventType["Group"] = "Group";
})(SpecialEventType || (SpecialEventType = {}));
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/analytics/dist/ampli-variant.js


// Grabs all props from class and first prototype
const getAllAmpliProps = (obj) => Array.from(new Set([...Object.keys(obj), ...Object.getOwnPropertyNames(Object.getPrototypeOf(obj))]));
const ampliSdkWithNoEventProps = getAllAmpliProps(ampli);
const DEFAULT_AMPLI_INSTANCE_NAME = 'care-ampli-instance';
/**
 * Care Specific wrapper of AmpliSDK
 */
class CareAmpli {
    constructor() {
        // Initializes Amplitude client and loads ampli
        this.initializeAmplitude = () => {
            const { analyticsEnabled, isProd, instanceName, ampliModule } = this.config;
            const { ampli, ApiKey, DefaultOptions } = ampliModule;
            if (analyticsEnabled &&
                (!ApiKey || (isProd && !ApiKey.production) || (!isProd && !ApiKey.development))) {
                throw new Error('CareAmpli: Missing Analytics key');
            }
            // There are only two environments/projects for Ampli
            const apiKey = ApiKey[isProd ? 'production' : 'development'];
            // Using a named instance is safer in cases where the consuming MFE is still using original Ampltiude set up
            const amplitudeInstance = amplitude_esm/* default.getInstance */.Z.getInstance(instanceName || DEFAULT_AMPLI_INSTANCE_NAME);
            amplitudeInstance.init(apiKey, undefined, DefaultOptions);
            ampli.load({
                disabled: !analyticsEnabled,
                client: { instance: amplitudeInstance },
            });
        };
        // Overwrite events to include common data using 'withCommonData' function
        this.createModifiedAmpliSdk = () => getAllAmpliProps(this.unmodifiedAmpli).reduce((acc, ampliProp) => {
            const ampliValue = this.unmodifiedAmpli[ampliProp];
            /* Skip modified properties if...
                1) not a function
                2) a built-in Ampli function
                3) function where the number of arguments is not 3 (expected number for events with properties)
            */
            if (typeof ampliValue !== 'function') {
                // Define as a getter so we are accessing the same values as unmodified and not copying primitives
                const ampliHelperThis = this;
                Object.defineProperty(acc, ampliProp, {
                    get: () => ampliHelperThis.unmodifiedAmpli[ampliProp],
                });
                return acc;
            }
            if (ampliSdkWithNoEventProps.includes(ampliProp) || ampliValue.length !== 3) {
                // Point it to the same function - can't make these getters or it messes with jest.spyOn
                acc[ampliProp] = ampliValue;
                return acc;
            }
            // "Should" be an event function
            // One known issue with this is we have no way of checking if eventProps includes all of common data's props
            // This is guarded by TypeScript but could be circumvented with improper type casting
            acc[ampliProp] = (eventProps, options, extra) => this.withCommonData(ampliValue, eventProps, options, extra);
            return acc;
        }, {});
        // Calls the provided function but adds common data to the event props
        this.withCommonData = (method, eventPropsWithoutCommonData, options, extra) => {
            var _a, _b;
            const eventProps = eventPropsWithoutCommonData
                ? Object.assign(Object.assign({}, (_a = this.getCommonData) === null || _a === void 0 ? void 0 : _a.call(this)), eventPropsWithoutCommonData) : (_b = this.getCommonData) === null || _b === void 0 ? void 0 : _b.call(this);
            // Need to re-bind "this" for methods to run properly
            return method.call(this.unmodifiedAmpli, eventProps, options, extra);
        };
    }
    /**
     * A function that gets the common data.
     */
    get getCommonData() {
        var _a;
        // Readonly to avoid changing common data fn - would break typing
        return (_a = this === null || this === void 0 ? void 0 : this.config) === null || _a === void 0 ? void 0 : _a.commonDataFn;
    }
    /**
     * Readonly property for being able to get the unmodified
     * Ampli object passed into the `initialize` method.
     */
    get unmodified() {
        const careAmpliThis = this;
        return {
            // Double readonly property - need the "<anything>.ampli.<eventFn>" syntax for ampli status command
            get ampli() {
                return careAmpliThis.unmodifiedAmpli;
            },
        };
    }
    /**
     * Property for accessing the current state of the underlying Ampli
     */
    get ampli() {
        return this === null || this === void 0 ? void 0 : this.modifiedAmpli;
    }
    /**
     * A method to initialize the CareAmpli and must be called
     * before attempting to use any other property or method.
     */
    initialize(config) {
        if (!config)
            throw new Error('CareAmpli: Missing config');
        this.config = config;
        this.unmodifiedAmpli = config.ampliModule.ampli;
        this.initializeAmplitude();
        this.modifiedAmpli = this.getCommonData
            ? this.createModifiedAmpliSdk()
            : this.unmodifiedAmpli;
    }
}
//# sourceMappingURL=data:application/json;base64,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
;// CONCATENATED MODULE: ./node_modules/@care/analytics/dist/index.js


let amplitudeInstance;
let analyticsConfig;
const tempEventsBuffer = [];
const tempUserPropsBuffer = [];
/**
 * A function that logs an event in amplitude.
 */
function logEvent(payload) {
    let combinedAttributes;
    let status;
    if (!payload || !payload.name) {
        throw new Error('CareAnalytics: Invalid event payload');
    }
    if (amplitudeInstance && analyticsConfig.analyticsEnabled) {
        const eventData = payload.data ? payload.data : {};
        analyticsConfig.commonData = analyticsConfig.commonData ? analyticsConfig.commonData : {};
        combinedAttributes = Object.assign(Object.assign({ url: document.location.href, url_path: document.location.pathname }, analyticsConfig.commonData), eventData);
        amplitudeInstance.logEvent(payload.name, combinedAttributes);
        status = 'CareAnalytics: Event logged';
    }
    else {
        tempEventsBuffer.push(payload);
        status = 'CareAnalytics: Event buffered';
    }
    return status;
}
/**
 * A function that updates the user and/or user props in amplitude.
 */
const setUserProps = (user) => {
    let status;
    if (!amplitudeInstance) {
        tempUserPropsBuffer.push(user);
        status = 'CareAnalytics: Properties can only be set after Amplitude is initialized';
    }
    else {
        if (user.memberId) {
            amplitudeInstance.setUserId(user.memberId);
        }
        if (user.props) {
            amplitudeInstance.setUserProperties(user.props);
        }
        status = 'CareAnalytics: User properties set successfully';
    }
    return status;
};
/**
 * A function for initializing amplitude.
 */
const init = (config) => {
    var _a, _b, _c, _d, _e, _f;
    let status;
    if (!config) {
        throw new Error('CareAnalytics: Missing config');
    }
    else if (config.analyticsEnabled === false) {
        status = 'CareAnalytics: Analytics disabled';
    }
    else if (!config.key) {
        throw new Error('CareAnalytics: Missing Analytics key');
    }
    else if (!amplitudeInstance) {
        amplitudeInstance = amplitude_esm/* default.getInstance */.Z.getInstance();
        amplitudeInstance.init(config.key, (_a = config.user) === null || _a === void 0 ? void 0 : _a.memberId, config.amplitudeConfig);
        const userAgent = (_c = (_b = window === null || window === void 0 ? void 0 : window.navigator) === null || _b === void 0 ? void 0 : _b.userAgent) === null || _c === void 0 ? void 0 : _c.toLowerCase();
        const isAndroidWebview = userAgent === null || userAgent === void 0 ? void 0 : userAgent.includes('wv');
        let androidAppInfo;
        try {
            if (isAndroidWebview) {
                androidAppInfo = JSON.parse((_e = (_d = window === null || window === void 0 ? void 0 : window.SeekerWebView) === null || _d === void 0 ? void 0 : _d.getAppInfo) === null || _e === void 0 ? void 0 : _e.call(_d));
            }
            // eslint-disable-next-line no-empty
        }
        catch (e) { }
        const userProperties = Object.assign(Object.assign({}, config.user), { props: Object.assign(Object.assign(Object.assign({}, (_f = config.user) === null || _f === void 0 ? void 0 : _f.props), { web_platform: (window === null || window === void 0 ? void 0 : window.innerWidth) < 600 ? 'Mobile Web' : 'Desktop Web' }), (isAndroidWebview && {
                web_platform: 'Android Webview',
                app_name: androidAppInfo === null || androidAppInfo === void 0 ? void 0 : androidAppInfo.app_name,
                app_build: androidAppInfo === null || androidAppInfo === void 0 ? void 0 : androidAppInfo.app_build,
                app_version: androidAppInfo === null || androidAppInfo === void 0 ? void 0 : androidAppInfo.app_version,
            })) });
        setUserProps(userProperties);
        analyticsConfig = Object.assign(Object.assign({}, config), { 
            // merge in any commonData that was set prior to init
            commonData: Object.assign(Object.assign({}, ((analyticsConfig === null || analyticsConfig === void 0 ? void 0 : analyticsConfig.commonData) || {})), config.commonData) });
        status = 'CareAnalytics: initialization successful';
        if (tempUserPropsBuffer.length) {
            tempUserPropsBuffer.forEach((user) => setUserProps(user));
        }
        if (tempEventsBuffer.length) {
            tempEventsBuffer.forEach((payload) => logEvent(payload));
        }
    }
    return status;
};
/**
 * A function that take an object of data, merges it with the existing commonData.
 */
const updateCommonData = (data) => {
    analyticsConfig = analyticsConfig || { key: '' };
    analyticsConfig.commonData = Object.assign(Object.assign({}, (analyticsConfig.commonData || {})), data);
    return Object.assign({}, analyticsConfig.commonData);
};
/**
 * A function used to get the current amplitude instance.
 */
const getInstance = () => {
    return amplitudeInstance;
};

//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 54887:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ query_string; }
});

// NAMESPACE OBJECT: ./node_modules/query-string/base.js
var base_namespaceObject = {};
__webpack_require__.r(base_namespaceObject);
__webpack_require__.d(base_namespaceObject, {
  "exclude": function() { return exclude; },
  "extract": function() { return extract; },
  "parse": function() { return parse; },
  "parseUrl": function() { return parseUrl; },
  "pick": function() { return pick; },
  "stringify": function() { return stringify; },
  "stringifyUrl": function() { return stringifyUrl; }
});

;// CONCATENATED MODULE: ./node_modules/decode-uri-component/index.js
const token = '%[a-f0-9]{2}';
const singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
const multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	const left = components.slice(0, split);
	const right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch {
		let tokens = input.match(singleMatcher) || [];

		for (let i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	const replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD',
	};

	let match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch {
			const result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	const entries = Object.keys(replaceMap);

	for (const key of entries) {
		// Replace all decoded components
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

function decodeUriComponent(encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
}

;// CONCATENATED MODULE: ./node_modules/split-on-first/index.js
function splitOnFirst(string, separator) {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (string === '' || separator === '') {
		return [];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
}

;// CONCATENATED MODULE: ./node_modules/filter-obj/index.js
function includeKeys(object, predicate) {
	const result = {};

	if (Array.isArray(predicate)) {
		for (const key of predicate) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor?.enumerable) {
				Object.defineProperty(result, key, descriptor);
			}
		}
	} else {
		// `Reflect.ownKeys()` is required to retrieve symbol properties
		for (const key of Reflect.ownKeys(object)) {
			const descriptor = Object.getOwnPropertyDescriptor(object, key);
			if (descriptor.enumerable) {
				const value = object[key];
				if (predicate(key, value, object)) {
					Object.defineProperty(result, key, descriptor);
				}
			}
		}
	}

	return result;
}

function excludeKeys(object, predicate) {
	if (Array.isArray(predicate)) {
		const set = new Set(predicate);
		return includeKeys(object, key => !set.has(key));
	}

	return includeKeys(object, (key, value, object) => !predicate(key, value, object));
}

;// CONCATENATED MODULE: ./node_modules/query-string/base.js




const isNullOrUndefined = value => value === null || value === undefined;

// eslint-disable-next-line unicorn/prefer-code-point
const strictUriEncode = string => encodeURIComponent(string).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index': {
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result, [encode(key, options), '[', index, ']'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join(''),
				];
			};
		}

		case 'bracket': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), '[]'].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), '[]=', encode(value, options)].join(''),
				];
			};
		}

		case 'colon-list-separator': {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						[encode(key, options), ':list='].join(''),
					];
				}

				return [
					...result,
					[encode(key, options), ':list=', encode(value, options)].join(''),
				];
			};
		}

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator'
				? '[]='
				: '=';

			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default: {
			return key => (result, value) => {
				if (
					value === undefined
					|| (options.skipNull && value === null)
					|| (options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [
						...result,
						encode(key, options),
					];
				}

				return [
					...result,
					[encode(key, options), '=', encode(value, options)].join(''),
				];
			};
		}
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index': {
			return (key, value, accumulator) => {
				result = /\[(\d*)]$/.exec(key);

				key = key.replace(/\[\d*]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};
		}

		case 'bracket': {
			return (key, value, accumulator) => {
				result = /(\[])$/.exec(key);
				key = key.replace(/\[]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'colon-list-separator': {
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [...accumulator[key], value];
			};
		}

		case 'comma':
		case 'separator': {
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && base_decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? base_decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => base_decode(item, options)) : (value === null ? value : base_decode(value, options));
				accumulator[key] = newValue;
			};
		}

		case 'bracket-separator': {
			return (key, value, accumulator) => {
				const isArray = /(\[])$/.test(key);
				key = key.replace(/\[]$/, '');

				if (!isArray) {
					accumulator[key] = value ? base_decode(value, options) : value;
					return;
				}

				const arrayValue = value === null
					? []
					: value.split(options.arrayFormatSeparator).map(item => base_decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [...accumulator[key], ...arrayValue];
			};
		}

		default: {
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [...[accumulator[key]].flat(), value];
			};
		}
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function base_decode(value, options) {
	if (options.decode) {
		return decodeUriComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parse(query, options) {
	options = {
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false,
		...options,
	};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const returnValue = Object.create(null);

	if (typeof query !== 'string') {
		return returnValue;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return returnValue;
	}

	for (const parameter of query.split('&')) {
		if (parameter === '') {
			continue;
		}

		const parameter_ = options.decode ? parameter.replace(/\+/g, ' ') : parameter;

		let [key, value] = splitOnFirst(parameter_, '=');

		if (key === undefined) {
			key = parameter_;
		}

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : (['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : base_decode(value, options));
		formatter(base_decode(key, options), value, returnValue);
	}

	for (const [key, value] of Object.entries(returnValue)) {
		if (typeof value === 'object' && value !== null) {
			for (const [key2, value2] of Object.entries(value)) {
				value[key2] = parseValue(value2, options);
			}
		} else {
			returnValue[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return returnValue;
	}

	// TODO: Remove the use of `reduce`.
	// eslint-disable-next-line unicorn/no-array-reduce
	return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key) => {
		const value = returnValue[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

function stringify(object, options) {
	if (!object) {
		return '';
	}

	options = {encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',', ...options};

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key]))
		|| (options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const [key, value] of Object.entries(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = value;
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
}

function parseUrl(url, options) {
	options = {
		decode: true,
		...options,
	};

	let [url_, hash] = splitOnFirst(url, '#');

	if (url_ === undefined) {
		url_ = url;
	}

	return {
		url: url_?.split('?')?.[0] ?? '',
		query: parse(extract(url), options),
		...(options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: base_decode(hash, options)} : {}),
	};
}

function stringifyUrl(object, options) {
	options = {
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true,
		...options,
	};

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = extract(object.url);

	const query = {
		...parse(queryFromUrl, {sort: false}),
		...object.query,
	};

	let queryString = stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		const urlObjectForFragmentEncode = new URL(url);
		urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
		hash = options[encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
}

function pick(input, filter, options) {
	options = {
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false,
		...options,
	};

	const {url, query, fragmentIdentifier} = parseUrl(input, options);

	return stringifyUrl({
		url,
		query: includeKeys(query, filter),
		fragmentIdentifier,
	}, options);
}

function exclude(input, filter, options) {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return pick(input, exclusionFilter, options);
}

;// CONCATENATED MODULE: ./node_modules/query-string/index.js


/* harmony default export */ var query_string = (base_namespaceObject);


/***/ })

}]);